export default "__VITE_ASSET__54fRt2Sd__"